import { EventBase, InteractiveChannelProvider } from "@vp/models";

export interface CallWebhookEventArgs {
  applicationHostId: string;
  deviceId: string;
  topic: string;
  startTime?: string;
  endTime?: string;
  interactiveChannelProviderType: InteractiveChannelProvider;
}

export class CallWebhookEvent extends EventBase<CallWebhookEventArgs> {
  constructor(args: CallWebhookEventArgs) {
    super();
    this.args = args;
  }
}
